module.exports = __webpack_public_path__ + "media/src/application/media/route_1-f188f280a7a2ccc596016bcd7d1c7235.webp";